import React, { useRef, useEffect } from 'react'
import * as d3 from 'd3'
import { color } from 'd3'
import parliament from '@kyuumeitai/d3-parliament'

const Hemiciclo = ({ width, height, data, stroke }) => {
  const ref = useRef(null)

  useEffect(() => {
    const svg = d3.select(ref.current)
    const parliaments = parliament({ animate: false })
      .innerRadiusCoef(0.51)
      .width(width)
      .height(height)

    svg
      .data([data])
      .call(parliaments)
      .selectAll('circle')
      .attr('fill', d => {
        return color(d.party.color ? d.party.color : '#ccc')
      })
  }, [stroke, data, height, width])

  return (
    <div className="pb-2">
      <svg
        ref={ref}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid meet"
        className="p-2"
      />
    </div>
  )
}

export default Hemiciclo
